export enum ContractConfigStep {
  BasicDetails = 'Basic Details',
  FilterConfig = 'Contract Filters',
  EditContract = 'Edit Contract',
  ReviewContract = 'Review Contract',
  ReviewSchema = 'Review Schema',
  ContractCreated = 'Contract Created',
  ContractUpdated = 'Contract Updated',
}

export enum ContractConfigWorkflow {
  create = 'create',
  edit = 'edit',
}

// These are the new workflows implemented by the Filter Preview work
const CreateContractConfigWorkflowSteps = [
  ContractConfigStep.BasicDetails,
  ContractConfigStep.FilterConfig,
  ContractConfigStep.ReviewSchema,
  ContractConfigStep.ContractCreated,
];
const EditContractConfigWorkflowSteps = [
  ContractConfigStep.EditContract,
  ContractConfigStep.ReviewSchema,
  ContractConfigStep.ContractUpdated,
];

export const getContractConfigWorkflowSteps = (
  workflow: ContractConfigWorkflow,
): Array<ContractConfigStep> => {
  switch (workflow) {
    case ContractConfigWorkflow.create:
      return CreateContractConfigWorkflowSteps;

    case ContractConfigWorkflow.edit:
      return EditContractConfigWorkflowSteps;

    default:
      return CreateContractConfigWorkflowSteps;
  }
};
